import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-lecturers',
  templateUrl: './add-lecturers.component.html',
  styleUrls: ['./add-lecturers.component.scss']
})
export class AddLecturersComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
